import http from '@/uteis/http'

import axiosRetry from 'axios-retry'
axiosRetry(http, { retries: 3 })

export default class VirtusMensagemService {
  /**
   * TODO
   * [] Enviar a consulta de pegar interessados para usuarios service e passar o metodo dentro da api para a api interessados
   */
  async getInteressados (filter) {
    var url = '/d0593/pae-back/v1/mensagem/interessado'
    return new Promise((resolve, reject) => {
      http.get(url, { params: filter }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url, { params: filter }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async getMensagens (filter) {
    var url = '/d0593/pae-back/v1/mensagem'
    return new Promise((resolve, reject) => {
      http.get(url, { params: filter }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url, { params: filter }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async checkMensagem (identificador, securityKey) {
    return new Promise((resolve, reject) => {
      http.put(`/d0593/pae-back/v1/mensagem/${identificador}/visualizar`, null, {
        headers: {
          'security-key': securityKey
        }
      }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.put(`/d0593/pae-back/v1/mensagem/${identificador}/visualizar`, null, {
          headers: {
            'security-key': securityKey
          }
        }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async createMensagem (body, securityKey) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/mensagem', body, {
        headers: {
          'security-key': securityKey
        }
      }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/mensagem', body, {
          headers: {
            'security-key': securityKey
          }
        }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async updateMensagem (identificador, body, securityKey) {
    var url = `/d0593/pae-back/v1/mensagem/${identificador}`
    return new Promise((resolve, reject) => {
      http.put(url, body, {
        headers: {
          'security-key': securityKey
        }
      }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.put(url, body, {
          headers: {
            'security-key': securityKey
          }
        }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
